import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Dil dosyalarını içe aktarın
import translationEN from "./locales/en/en.json";
import translationTR from "./locales/tr/tr.json";

// localStorage için güvenli helper fonksiyonları
const safeLocalStorage = {
  getItem: (key) => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return localStorage.getItem(key);
      }
    } catch (error) {
      console.warn('localStorage getItem failed:', error);
    }
    return null;
  },

  setItem: (key, value) => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem(key, value);
        return true;
      }
    } catch (error) {
      console.warn('localStorage setItem failed:', error);
    }
    return false;
  }
};

// Dil dosyalarını tanımlayın
const resources = {
  en: {
    translation: translationEN,
  },
  tr: {
    translation: translationTR,
  },
};

// localStorage'dan dil tercihini al (sunucu tarafında güvenli)
const savedLanguage = safeLocalStorage.getItem('selectedLanguage') || 'tr';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage, // Kaydedilmiş dil veya varsayılan
  fallbackLng: ["tr", "en"], // Çoklu fallback dilleri
  debug: process.env.NODE_ENV === 'development', // Sadece development'ta debug
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
  },
  // Production için ek güvenlik
  load: 'languageOnly',
  cleanCode: true,
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
});

// Dil değişikliklerini localStorage'a kaydet (sunucu tarafında güvenli)
i18n.on('languageChanged', (lng) => {
  safeLocalStorage.setItem('selectedLanguage', lng);
});

export default i18n;
